<a-card>
  <div class="file-upload">
    <div class="file-upload-table">
      <table-wrapper
        :class="class"
        :tableHeight="34*((fileList?.length||4)+1)"
        :dataSource="fileList"
        :columns="columns"
        :showCheckbox="false"
      >
        <template #size="{ record }">
          <span>{{ $filters.humanizeFileSize(record.size) }}</span>
        </template>
        <template #status="{ record }">
          <file-status :status="record.status"></file-status>
        </template>
        <template #action="{ record }">
          <hmd-empty-link v-if="allowEdit" @click="deleteFile(record)"> 删除 </hmd-empty-link>
          <!-- <a v-perm="downloadAccess" :href="record.url" target="_blank">下载</a> -->
          <!-- <hmd-empty-link @click="openPreview(record.url)"> 预览 </hmd-empty-link> -->
          <download-file :url="record.url" :fileName="record.name">下载</download-file>
        </template>
      </table-wrapper>
    </div>
  </div>
</a-card>
